// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__KvG5C","boxTitle":"Qualiphy_boxTitle__1Dek1","box":"Qualiphy_box__2Skl1","toggleWrap":"Qualiphy_toggleWrap__3RAzI"};